import { GenericFileDownloadDto, GenericTableDataFileDto } from 'inside-fifa/api/generic-tables/dto';
import { ActionsColumnFile } from './actions-columns-file';
import { Row } from 'react-table';

export const ActionsCell = ({
    row,
    onDelete,
    onDownload,
}: {
    row: Row<GenericTableDataFileDto>;
    onDelete: (file: GenericTableDataFileDto) => Promise<GenericTableDataFileDto>;
    onDownload: (file: GenericTableDataFileDto) => Promise<GenericFileDownloadDto>;
}) => {
    return (
        <ActionsColumnFile
            row={row.original}
            onDelete={() => onDelete(row.original)}
            onDownload={() => onDownload(row.original)}
        />
    );
};
